import script from "./QModalConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./QModalConfirmation.vue?vue&type=style&index=0&id=b1f2de9a&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1f2de9a"]])

export default __exports__